<template>
  <svg
    :width="width ? width : height ? height * (22 / 14) : 22"
    :height="height ? height : width ? width * (14 / 22) : 14"
    viewBox="0 0 22 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Reiseplanlegger"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Evt-forside"
        transform="translate(-89.000000, -832.000000)"
        :fill="iconColor"
        fill-rule="nonzero"
      >
        <path
          d="M109.887298,835.572123 L100.734543,832.76008 C100.235791,832.606845 99.6976641,832.606845 99.1992403,832.76008 L90.0461576,835.572123 C89.2737484,835.809358 89.2737484,836.830815 90.0461576,837.06805 L91.6418357,837.558271 C91.291725,837.99107 91.0764741,838.519025 91.0551459,839.097183 C90.7391603,839.278309 90.5166907,839.605123 90.5166907,839.995265 C90.5166907,840.348985 90.7030664,840.646596 90.9714737,840.836909 L90.1337673,844.606424 C90.0609233,844.934222 90.3102993,845.245285 90.6459725,845.245285 L92.487089,845.245285 C92.8230903,845.245285 93.0724663,844.934222 92.9996223,844.606424 L92.1619159,840.836909 C92.4303232,840.646596 92.6166989,840.348985 92.6166989,839.995265 C92.6166989,839.615623 92.4044012,839.297997 92.1028532,839.11359 C92.1277908,838.620744 92.3797917,838.184992 92.7817464,837.90871 L99.1989121,839.880421 C99.4961945,839.97164 100.066478,840.0855 100.734215,839.880421 L109.887298,837.068378 C110.660035,836.830815 110.660035,835.809686 109.887298,835.572123 Z M101.042654,840.884159 C100.106509,841.171598 99.3088344,841.012784 98.8904734,840.884159 L94.1319861,839.422356 L93.666703,843.145277 C93.666703,844.305204 96.4872765,845.245285 99.9667276,845.245285 C103.446179,845.245285 106.266752,844.305204 106.266752,843.145277 L105.801469,839.422028 L101.042654,840.884159 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'graduation',
  props: {
    iconColor: {
      type: String,
      default: '#D2D5E4',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
